import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable()
export class EvaluationsService {
  private _apiUrl = '/api/EvaluationTemplates';
  links: { title: string; url: any; }[];
  constructor(private _http: HttpService, private _httpClient: HttpClient) { }

  //Get All Evaluations
  getAllEvaluationTemplates(clubID: number) {
    return this._http.get(
      this._apiUrl + '/get-evaluation-templates-by-clubID/' + clubID
    );
  }

  getEvaluatorsAndTemplatesForPlayersByClubID(clubID: number) {
    return this._http.get(
      this._apiUrl + '/get-evaluators-and-templates-for-players-by-clubID/' + clubID
    );
  }

  getEvaluationPlayersByClubID(clubID: number) {
    return this._http.get(
      this._apiUrl + '/load-evaluation-template-players-by-clubID/' + clubID
    );
  }

  getEvaluationStaffByClubID(clubID: number) {
    return this._http.get(
      this._apiUrl + '/load-evaluation-template-staff-by-clubID/' + clubID
    );
  }

  addEvaluationTemplate(payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        responseType: 'text'
      })
    };
    return this._http.post(
      this._apiUrl + '/add-new-evaluation-template',
      payload,
      httpOptions
    );
  }

  assignEvaluationTemplateToSelectedPlayers(payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        responseType: 'text'
      })
    };
    return this._http.post(
      this._apiUrl + '/assign-evaluation-template-to-selected-players',
      payload,
      httpOptions
    );
  }

  assignEvaluationTemplateToFilteredPlayers(payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        responseType: 'text'
      })
    };
    return this._http.post(
      this._apiUrl + '/assign-evaluation-template-to-filtered-players',
      payload,
      httpOptions
    );
  }

  updateTemplateStatus(status: number, templateIDs) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        responseType: 'text'
      })
    };
    return this._http.put(
      this._apiUrl + '/update-evaluation-template-status/' + status,
      templateIDs,
      httpOptions
    );
  }

  updateCategoryName(categoryID: number, payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        responseType: 'text'
      })
    };
    return this._http.put(
      this._apiUrl + '/update-category-name/' + categoryID,
      payload,
      httpOptions
    );

    // pdate-category-name/{categoryID}
  }

  updateQuestionDetails(questionID: number, payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        responseType: 'text'
      })
    };
    return this._http.put(
      this._apiUrl + '/update-question-details/' + questionID,
      payload,
      httpOptions
    );
  }

  duplicateTemplate(templateID: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        responseType: 'text'
      })
    };
    return this._http.post(
      this._apiUrl + '/duplicate-evaluation-template/' + templateID,
      httpOptions
    );
  }

  updateEvaluationTemplate(templateID: number, payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        responseType: 'text'
      })
    };
    return this._http.put(
      this._apiUrl + '/update-evaluation-template/' + templateID,
      payload,
      httpOptions
    );
  }

  removeEvaluationTemplates(templateIDs) {
    return this._httpClient.request(
      'delete',
      this._apiUrl + '/remove-evaluation-templates/',
      { body: templateIDs }
    );
  }

  removeEvaluationCategories(categoryIDs) {
    return this._httpClient.request(
      'delete',
      this._apiUrl + '/remove-evaluation-categories/',
      { body: categoryIDs }
    );
  }

  removeEvaluationQuestions(questionIDs) {
    return this._httpClient.request(
      'delete',
      this._apiUrl + '/remove-evaluation-questions/',
      { body: questionIDs }
    );
  }

  removePlayerEvaluationByID(evaluationID) {
    return this._httpClient.request(
      'delete',
      this._apiUrl + '/remove-player-evaluation-by-id/',
      { body: evaluationID }
    );
  }

  //LOAD EVALUATION TEMPLATE DETAILS
  loadEvaluationTemplateDetails(evaluationTemplateID) {
    return this._httpClient.get(
      this._apiUrl + '/load-evaluation-template-details/' + evaluationTemplateID
    );
  }

  loadEvaluationsFlyoutByPlayerIdAndClubId(playerID: number, clubID: number) {
    return this._httpClient.get(`${this._apiUrl}/load-evaluations-flyout-by-player-id-and-club-id/${playerID}/${clubID}`);
  }

  loadEvaluationsByPlayerIdAndClubId(playerID: number, clubID: number) {
    return this._httpClient.get(`${this._apiUrl}/load-evaluations-by-player-id-and-club-id/${playerID}/${clubID}`);
  }

  loadEvaluationsByStaffID(staffID, clubID) {
    return this._httpClient.get(
      this._apiUrl + '/load-evaluations-by-staff-id/' + staffID + '/' + clubID
    );
  }

  loadEvaluationTemplateResults(playerID, userEvaluationID) {
    return this._httpClient.get(
      this._apiUrl + '/load-evaluation-template-results/' + playerID + '/' + userEvaluationID);
  }

  updateEvaluationTemplateResult(userEvaluationID, userID, evaluationPresetCategoryID, payload) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        responseType: 'text'
      })
    };
    // console.log('Payload = ', payload);
    return this._http.post(
      this._apiUrl + '/update-evaluation-template-result/' + userEvaluationID + '/' + userID + '/' + (evaluationPresetCategoryID || 0),
      payload,
      httpOptions
    );
  }

  addCategoryToEvaluationTemplate(payload) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        responseType: 'text'
      })
    };
    return this._http.post(
      this._apiUrl + '/add-category-to-evaluation-template',
      payload,
      httpOptions
    );
  }

  addQuestionToCategoryInEvaluationTemplate(payload) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        responseType: 'text'
      })
    };
    return this._http.post(
      this._apiUrl + '/add-question-to-category-in-evaluation-template',
      payload,
      httpOptions
    );
  }
  removeStaff(ids: number[]) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      }),
      body: {
        UserEvaluationIDs: ids,
      }
    };
    return this._http.delete(this._apiUrl + '/remove-user-evaluations', httpOptions);
  }


  printOutEvaluationSheet(obj: any) {
    return this._httpClient.post(this._apiUrl + '/print-out-evaluation-sheet', obj);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/evaluations.service.ts